

const OneMedical = ({
    SurgeryFormData,
    setSurgeryFormData,
    currentPage,
    pageRefs,
    pageTitles,
    isNext,
    invalidFields,
    handleInputChange,
    handleCheckboxChange,
    verifyDob,
    setVerifyDob,
    signatures,
    setSignatures,
    isEditing,
    toggleEditMode,
    updateSignatureData,
    clearSignature,
    canvasRefs,
    surgeonOptionsMap,
    docSignature,
    logo,
    renderNextButton,
    renderSurgeryUploadButton,
    surgeryUpload,
    formatDate,
    handleMedicationTimeChange,
    getCentralAmericaDate,
    getCentralAmericaTime,
    handleNext,
    Paragraph,
    Logo,
    Head,
    SignatureField,
    TextInput,
    MedTimePicker,
    TextArea,
    DatePickerInput,
    RadioGroup,
    RSIConsent
}) => {
    return (
        <>
            <form className="bg-white">

                {/* PAGE 0 */}
                {currentPage === 0 && (
                    <RSIConsent
                        pageRefs={pageRefs}
                        currentPage={currentPage}
                        logo={logo}
                        pageTitles={pageTitles}
                        SurgeryFormData={SurgeryFormData}
                        surgeonOptionsMap={surgeonOptionsMap}
                        docSignature={docSignature}
                        setSignatures={setSignatures}
                        setSurgeryFormData={setSurgeryFormData}
                        handleInputChange={handleInputChange}
                        invalidFields={invalidFields}
                        isNext={isNext}
                        isEditing={isEditing}
                        signatures={signatures}
                        canvasRefs={canvasRefs}
                        updateSignatureData={updateSignatureData}
                        clearSignature={clearSignature}
                        toggleEditMode={toggleEditMode}
                        getCentralAmericaDate={getCentralAmericaDate}
                        getCentralAmericaTime={getCentralAmericaTime}
                        Logo={Logo}
                        Head={Head}
                        Paragraph={Paragraph}
                        RadioGroup={RadioGroup}
                        TextInput={TextInput}
                        SignatureField={SignatureField} />
                )}

                {/* PAGE 1 */}
                {currentPage === 1 && (
                    <div ref={pageRefs.current[currentPage]} className="max-w-4xl w-full bg-white px-2 mx-5 py-2">
                        {/* page 1 JSX */}
                        <div className="bg-white p-6 flex items-center  justify-between gap-4">
                            {/* Left word */}
                            <span className="text-lg font-medium">
                                <span className="text-black-500">Summit Surgery Center</span>
                            </span>

                            {/* Right word - bigger and bolder */}
                            <span className="text-2xl font-bold">
                                <span className="text-black-500">PHYSICIAN'S ORDERS</span>
                            </span>
                        </div>

                        <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <label htmlFor='generically_acceptable' className="flex items-center space-x-2 select-none my-4">
                                <input
                                    type="checkbox"
                                    id='generically_acceptable'
                                    disabled={isNext}
                                    checked={SurgeryFormData.generically_acceptable || false}
                                    onChange={(e) =>
                                        setSurgeryFormData((prev) => ({
                                            ...prev,
                                            generically_acceptable: !SurgeryFormData.generically_acceptable,
                                        }))
                                    }
                                    className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                                />
                                <span className="text-base font-medium text-black">
                                    Generic Equivalent Acceptable for all medication orders
                                </span>

                            </label>

                        </div>
                        <div className="border-2 border-grey p-4 w-full">
                            <label htmlFor='nka' className="flex items-center space-x-2 select-none my-4">
                                <input
                                    type="checkbox"
                                    id='nka'
                                    disabled={isNext}
                                    checked={SurgeryFormData.nka || false}
                                    onChange={(e) =>
                                        setSurgeryFormData((prev) => ({
                                            ...prev,
                                            nka: !SurgeryFormData.nka,
                                        }))
                                    }
                                    className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                                />
                                <span className="text-base font-medium text-black">
                                    NKA
                                </span>

                            </label>
                            <TextInput
                                id="allergies"
                                label="Allergies"
                                value={SurgeryFormData.allergies}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("allergies") && !SurgeryFormData.allergies}
                            />
                        </div>
                        <div className="border-2 border-grey p-4 w-full">
                            <p className="text-xl font-bold text-center">
                                PREOPERATIVE ORDERS
                            </p>
                        </div>
                        <div className="border-2 border-grey p-4 w-full">
                            <TextInput
                                id="diagnosis"
                                label="Diagnosis"
                                required
                                value={SurgeryFormData.diagnosis}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("diagnosis") && !SurgeryFormData.diagnosis}
                            />
                        </div>
                        <div className="border-2 border-grey p-4 w-full">
                            <TextInput
                                id="procedure_description"
                                label="Procedure"
                                required
                                value={SurgeryFormData.procedure_description}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("procedure_description") && !SurgeryFormData.procedure_description}
                            />
                        </div>

                        <div className="border-2 border-grey p-4 w-full">

                            {/* Requested Date of surgery */}
                            <DatePickerInput
                                id="requested_date_of_surgery"
                                label="1. Admit to Surgery Center"
                                value={SurgeryFormData.requested_date_of_surgery}
                                onChange={(date) =>
                                    setSurgeryFormData((prev) => ({
                                        ...prev,
                                        requested_date_of_surgery: date ? formatDate(date) : "",
                                    }))
                                }
                                disabled={isNext}
                                invalid={
                                    invalidFields.includes("requested_date_of_surgery") &&
                                    !SurgeryFormData.requested_date_of_surgery
                                }
                                minDate={new Date()}
                            />
                        </div>

                        <div className="border-2 border-grey p-4 w-full">

                            <TextInput
                                id="vital_signs"
                                label="2. Vital signs: Upon admission then routine"
                                required
                                value={SurgeryFormData.vital_signs}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("vital_signs") && !SurgeryFormData.vital_signs}
                            />
                        </div>

                        <div className="border-2 border-grey p-4 w-full">

                            <p className="text-base text-black leading-relaxed my-4">
                                3. Diet:
                            </p>

                            <div className="flex flex-wrap gap-4">
                                <label htmlFor='npo' className="flex items-center space-x-2 select-none my-4">
                                    <input
                                        type="checkbox"
                                        id='npo'
                                        disabled={isNext}
                                        checked={SurgeryFormData.npo || false}
                                        onChange={(e) =>
                                            setSurgeryFormData((prev) => ({
                                                ...prev,
                                                npo: !SurgeryFormData.npo,
                                            }))
                                        }
                                        className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                                    />
                                    <span className="text-base font-medium text-black">
                                        NPO
                                    </span>

                                </label>
                                <TextInput
                                    id="other_diet"
                                    label=""
                                    value={SurgeryFormData.other_diet}
                                    onChange={handleInputChange}
                                    disabled={isNext}
                                    invalid={invalidFields.includes("other_diet") && !SurgeryFormData.other_diet}
                                />
                            </div>


                        </div>

                        <div className="border-2 border-grey p-4 w-full">

                            <TextInput
                                id="anesthesia"
                                label="4. IV: Per Anesthesia"
                                required
                                value={SurgeryFormData.anesthesia}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("anesthesia") && !SurgeryFormData.anesthesia}
                            />
                        </div>
                        <div className="border-2 border-grey p-4 w-full">

                            <TextInput
                                id="labs_anesthesia"
                                label="Labs: Per Anesthesia"
                                required
                                value={SurgeryFormData.labs_anesthesia}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("labs_anesthesia") && !SurgeryFormData.labs_anesthesia}
                            />
                        </div>
                        <div className="border-2 border-gray p-4 w-full">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                                {/* LEFT COLUMN */}
                                <div>
                                    <p className="text-base text-black leading-relaxed mb-4">
                                        Preop Antibiotics: IVPB on call to OR
                                    </p>

                                    <div className="flex flex-wrap gap-4">
                                        {Object.keys(SurgeryFormData.one_medical_medications).map((order) => (
                                            <div key={order} className="flex items-center space-x-3">
                                                <input
                                                    type="checkbox"
                                                    disabled={isNext}
                                                    name={order}
                                                    checked={SurgeryFormData.one_medical_medications[order] === true}
                                                    onChange={() =>
                                                        handleCheckboxChange(
                                                            "one_medical_medications",
                                                            order,
                                                            !SurgeryFormData.one_medical_medications[order]
                                                        )
                                                    }
                                                    className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded"
                                                />
                                                <span className="text-black">{order}</span>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Show input box ONLY when "Other" is checked */}
                                    {SurgeryFormData.one_medical_medications["Other"] && (
                                        <div className="mt-4">
                                            <TextArea
                                                id="other_medication"
                                                value={SurgeryFormData.other_medication}
                                                onChange={handleInputChange}
                                                disabled={isNext}
                                            />
                                        </div>
                                    )}
                                </div>

                                {/* RIGHT COLUMN */}
                                <div>
                                    <p className="text-base text-black leading-relaxed mb-4">
                                        Pre-Op Medications
                                    </p>

                                    {Object.keys(SurgeryFormData.emerald_medication_times).map((med) => (
                                        <div key={med} className="space-y-2 mb-4">
                                            <p className="text-black">
                                                {med} one drop in operative eye every 5 minutes times 3 on call to OR Given at
                                            </p>

                                            <div className="grid grid-cols-3 gap-4">
                                                {SurgeryFormData.emerald_medication_times[med].map((time, index) => (
                                                    <MedTimePicker
                                                        key={index}
                                                        value={time}
                                                        onChange={(val) =>
                                                            handleMedicationTimeChange(
                                                                "emerald_medication_times",
                                                                med,
                                                                index,
                                                                val
                                                            )
                                                        }
                                                        disabled={surgeryUpload}
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>

                        <div className="border-2 border-grey p-4 w-full">

                            <TextInput
                                id="risk_assesment"
                                label="6. DVT Prophylaxis per Risk Assessment:"
                                required
                                value={SurgeryFormData.risk_assesment}
                                onChange={handleInputChange}
                                disabled={isNext}
                                invalid={invalidFields.includes("risk_assesment") && !SurgeryFormData.risk_assesment}
                            />
                        </div>

                        <div className="border-2 border-grey p-4 w-full">

                            <p className="text-base text-black leading-relaxed my-4">
                                7. Prep surgical site:
                            </p>

                            <div className="flex flex-wrap gap-4">
                                {Object.keys(SurgeryFormData.preop_surgical_site).map((order) => (
                                    <div key={order} className="flex items-center space-x-4">
                                        <input
                                            type="checkbox"
                                            disabled={isNext}
                                            name={order}
                                            checked={SurgeryFormData.preop_surgical_site[order] === true}
                                            onChange={() =>
                                                handleCheckboxChange(
                                                    "preop_surgical_site",
                                                    order,
                                                    !SurgeryFormData.preop_surgical_site[order]
                                                )
                                            }
                                            className="form-checkbox h-5 w-5 text-blue-600 border-gray-300 rounded"
                                        />
                                        <span className="text-black">{order}</span>
                                    </div>
                                ))}
                                <TextInput
                                    id="other_preop_surgical_site"
                                    label=""
                                    value={SurgeryFormData.other_preop_surgical_site}
                                    onChange={handleInputChange}
                                    disabled={isNext}
                                    invalid={invalidFields.includes("other_preop_surgical_site") && !SurgeryFormData.other_preop_surgical_site}
                                />
                            </div>


                        </div>

                        <div className="flex col-span-6">
                            <div className="w-[75%] mb-2">
                                <div className="font-semibold flex gap-2 text-black pb-4">

                                    <p>{SurgeryFormData.surgeon}</p>
                                    {SurgeryFormData['doctor_signature'] && (
                                        <>
                                            <p className="font-roboto text-base text-black whitespace-nowrap mx-1">
                                                {SurgeryFormData.operationDate}
                                            </p>
                                            <p className="font-roboto text-base text-black whitespace-nowrap">
                                                {SurgeryFormData.operationTime}
                                            </p>
                                            {!surgeryUpload && (
                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        setSurgeryFormData({
                                                            ...SurgeryFormData,
                                                            operationDate: getCentralAmericaDate(),
                                                            operationTime: getCentralAmericaTime(),
                                                        })
                                                    }
                                                    disabled={surgeryUpload}
                                                    className="p-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white focus:outline-none"
                                                    title="Set Central America Date & Time"
                                                >
                                                    <i className="fas fa-calendar-days text-white text-lg"></i>
                                                </button>
                                            )}
                                        </>
                                    )}
                                </div>

                                {SurgeryFormData['doctor_signature'] && !isEditing['doctor_signature'] ? ( // Toggle between edit and display mode

                                    <img
                                        src={SurgeryFormData['doctor_signature']}
                                        alt="Signature"
                                        loading="eager"
                                        style={{
                                            width: '300px',
                                            height: '100px',
                                            maxWidth: '100%',
                                            maxHeight: '100%',
                                            borderRadius: '0.375rem', // same as Tailwind's rounded-md
                                            border: '1px solid #D1D5DB', // Tailwind's border-gray-300
                                            objectFit: 'contain',
                                            display: 'block',
                                        }}
                                    />

                                ) : (
                                    null
                                )}

                            </div>
                        </div>


                        <div className="mb-4 flex flex-col sm:flex-row sm:items-start gap-6">
                            {/* Signature */}

                            <SignatureField
                                fieldName="noted_signature"
                                label="Noted Signature"
                                formData={SurgeryFormData}
                                isEditing={isEditing}
                                isDisabled={surgeryUpload}
                                signatures={signatures}
                                canvasRefs={canvasRefs}
                                invalidFields={invalidFields}
                                updateSignatureData={updateSignatureData}
                                clearSignature={clearSignature}
                                toggleEditMode={toggleEditMode}
                                isNext={surgeryUpload}
                            />

                            {/* Date & Time */}
                            <div className="mb-4 flex flex-col sm:flex-row flex-wrap gap-4 items-center">
                                {SurgeryFormData['noted_signature'] && (
                                    <>
                                        <p className="font-roboto text-base text-black whitespace-nowrap mx-1">
                                            {SurgeryFormData.noted_date}
                                        </p>
                                        <p className="font-roboto text-base text-black whitespace-nowrap">
                                            {SurgeryFormData.noted_time}
                                        </p>
                                    </>
                                )}
                            </div>
                        </div>

                    </div>

                )}

            </form>

            {/* Footer Buttons */}
            <div className="flex justify-end mx-5">
                    {[0].includes(currentPage)
                        ? renderNextButton()
                        : renderSurgeryUploadButton()}
            </div>
        </>
    );
};

export default OneMedical;
